import { RedeemedOffer } from 'api/types'
import {
  Discount,
  DiscountScope,
  DiscountType,
  OrderLineItemDiscount,
} from '@squareup/sq-addons-web-sdk'
import { order as squareOrderApi } from '@squareup/sq-addons-web-sdk'

export function convertRedeemedOfferToDiscount(offer: RedeemedOffer): Discount {
  return {
    name: `THANX ${offer.name}`,
    type: 'FIXED_AMOUNT' as DiscountType,
    scope: 'ORDER' as DiscountScope,
    amountMoney: {
      amount: Number(offer.discount.amount),
      currency: 'USD',
    },
    metadata: {
      offerId: offer.id,
      redemptionId: offer.redemption_id,
      provider: 'THANX',
    },
  }
}

export function getOfferName(
  discount: OrderLineItemDiscount | Discount
): string {
  if (!discount.name) return ''

  return discount.name.replace('THANX ', '')
}

export async function getOrderDiscount(): Promise<OrderLineItemDiscount | null> {
  try {
    const order = await squareOrderApi.retrieve()
    return (
      (order.discounts ?? []).find(
        discount => discount.metadata?.provider === 'THANX'
      ) ?? null
    )
  } catch (err) {
    return null
  }
}

export type AppliedDiscount = {
  offerId: string
  redemptionId: string
  discountId: string
}

export function hasDiscountAmountChanged(
  discount: OrderLineItemDiscount,
  offer: RedeemedOffer
): boolean {
  const currentAmount = discount.appliedMoney?.amount
  if (!currentAmount) return true

  return BigInt(offer.discount.amount) !== BigInt(currentAmount.toString())
}

export async function updateOrderDiscount(
  discountId: string,
  discount: Discount
) {
  await squareOrderApi.removeDiscount(discountId)
  await squareOrderApi.addDiscount(discount)
}

export function formatPointsBalance(balance: number): string {
  return Math.floor(balance)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
